import { formatUserFacingError } from '@/lib/errors'
import { useState } from 'react'
import { checkInTicketFn } from '@/lib/firebase/functions'

type CheckInState = 'idle' | 'scanning' | 'loading' | 'success' | 'error'

interface CheckInResult {
  purchaserName: string
  ticketTypeName: string
}

export function useCheckIn() {
  const [state, setState] = useState<CheckInState>('idle')
  const [result, setResult] = useState<CheckInResult | null>(null)
  const [errorMsg, setErrorMsg] = useState<string | null>(null)

  async function checkIn(qrToken: string) {
    setState('loading')
    setResult(null)
    setErrorMsg(null)
    try {
      const res = await checkInTicketFn({ qrToken })
      setResult(res.data)
      setState('success')
    } catch (err: unknown) {
      const msg = formatUserFacingError(err, 'Invalid ticket')
      setErrorMsg(msg)
      setState('error')
    }
  }

  function reset() {
    setState('idle')
    setResult(null)
    setErrorMsg(null)
  }

  function startScanning() {
    setState('scanning')
  }

  return { state, result, errorMsg, checkIn, reset, startScanning }
}
